(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["Chainge"] = factory(require("axios"));
	else
		root["Chainge"] = factory(root["axios"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__3300__) => {
return 